import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IFetchChatRes,IChat } from './index.type';

const useFetchChat = ({ patientId}: { patientId: string | undefined}) => {
  const [chatData, setChatData] = React.useState<IChat[]>([]);
  const [isAlertMessagesPresent, setIsAlertMessagesPresent] = React.useState<'yes' | 'no'>('no');

  const { loading: chatDataLoading, makeApiCall } = useApi({
    url: `/rtm/chat?patientId=${patientId}`,
    method: 'GET',
  });

  const getChatData = async (): Promise<{ success: boolean; data?: IChat[]; error?: string }> => {
    try {
      const { response, error } = await makeApiCall<undefined, IFetchChatRes>();
      
      if (response?.status === 'success') {
        setChatData(response.data || []);
        setIsAlertMessagesPresent(response.isAlertMessagesPresent || 'no');
        return { success: true, data: response.data };
      }

      if (response?.status === 'fail') {
        setChatData([]);
        setIsAlertMessagesPresent('no');
        return { success: false, error: 'Failed to fetch chat data' };
      }

      if (error) {
        toast.error(error?.msg || 'Unable to load chat messages. Please refresh and try again.');
        return { success: false, error: error.msg || 'Unknown error' };
      }

      return { success: false, error: 'No response from server' };
    } catch (error: any) {
      console.error('Error in getChatData:', error);
      return { success: false, error: error?.msg || 'Failed to load chat messages. Please refresh and try again.' };
    }
  };

  return {
    chatData,
    getChatData,
    chatDataLoading,
    isAlertMessagesPresent,
  };
};

export default useFetchChat;